import React, { useState, useEffect } from "react";
import ResultsTemplate from "../../../templates/ResultsTemplate";
import remoteQuizService from "../../../services/RemoteQuizService";
import { ClimbingBoxLoader } from "react-spinners";
import { Black } from "../../../components/theme/colors";

const ResultsLoveLanguages = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      const remoteConfig = await remoteQuizService.getQuizConfig(
        "love-languages"
      );
      setConfig(remoteConfig);
      setLoading(false);
    };
    fetchConfig();
  }, []);

  if (loading || !config) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: Black,
        }}
      >
        <ClimbingBoxLoader color="#ffffff" size={15} />
      </div>
    );
  }

  return <ResultsTemplate quizConfig={config} />;
};

export default ResultsLoveLanguages;
